import React, { useEffect } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import { Field } from 'formik';
import RxOrderContainer from "../../containers/RxOrder";
import { Select } from '@material-ui/core';

interface Props {
  meganetColorTypeId: number,
  meganetColorId: number,
  onChange: (meganetColorTypeId: any) => void,
}

export default ((props) => {

  const rxOrderContainer = RxOrderContainer.useContainer();
  const meganetColorTypeId = props.meganetColorTypeId || rxOrderContainer.colors[0].meganetColorTypeId;

  useEffect(() => {
    if (props.meganetColorTypeId === undefined) {
      props.onChange(meganetColorTypeId);
    }
  }, []);

  return (
    <Field style={{ fontSize: 13, }} required fullWidth name='colorType' label='Color Type' id='colorType' value={meganetColorTypeId} onChange={(event: React.ChangeEvent<HTMLSelectElement>) => props.onChange(event.target.value)} component={Select}>
      <MenuItem style={{ height: 30, }} key={-1} value={-1}>--</MenuItem>
      {rxOrderContainer.getColorTypeByMeganetColorId(props.meganetColorId).map(colorType => (
        <MenuItem key={colorType.meganetColorTypeId} value={colorType.meganetColorTypeId}>{colorType.colorTypeName}</MenuItem>)
      )}
    </Field>
  );
}) as React.FC<Props>;
